<template>
  <div class="container">
    <ca-slimbox size="large">
      <ca-row>
        <ca-col class="ca-u-text-center">
          <ca-heading text="Fazendo configuração da Conta Azul Mais Folha"></ca-heading>
        </ca-col>
      </ca-row>

      <ca-row vertical-offset="2">
        <ca-col>
          <ca-loader></ca-loader>
        </ca-col>
      </ca-row>

      <ca-row vertical-offset="2">
        <ca-col class="ca-u-text-center">
          <p>
            Estamos processando sua solicitação, aguarde um momento e logo
            sua conta estara pronta para ser usada.
            Você pode navegar em outras áreas da
            Conta Azul Mais por enquanto e voltar quando quiser.
          </p>
        </ca-col>
      </ca-row>

      <ca-footer>
        <ca-row vertical-offset="2">
          <ca-col size="3">
            <ca-button full-width @click="goBack">
              Voltar para meus clientes
            </ca-button>
          </ca-col>
        </ca-row>
      </ca-footer>
    </ca-slimbox>
  </div>
</template>

<script>
import { OK } from 'http-status-codes';
import { checkActivation, enterApp } from './activationService';

export default {
  name: 'ActivationWaitingPage',
  created() {
    setInterval(async () => {
      const { status } = await checkActivation();

      if (status === OK) {
        enterApp();
      }
    }, 5000);
  },
  methods: {
    goBack() {
      window.location.assign(process.env.VUE_APP_ACC_WEBAPP);
    },
  },
};
</script>
